import ProfitabilityReport from './ProfitabilityReport';

export default function ProfitAgent() {
  return <ProfitabilityReport variant="profit-agent" />;
}
